import { type SearchDomainIndexName } from '~/apps/product-plus/search-domain/indexes';
import { bettingSplitsPipelineDefinition } from '~/apps/product-plus/search-domain/pipelines/betting-splits/pipeline';
import { eventOverviewPipelineDefinition } from '~/apps/product-plus/search-domain/pipelines/event-overview/pipeline';
import { matchupCentrePipelineDefinition } from '~/apps/product-plus/search-domain/pipelines/match-centre/pipeline';
import { playerDataPipelineDefinition } from '~/apps/product-plus/search-domain/pipelines/player-data/pipeline';
import { positiveEvPipelineDefinition } from '~/apps/product-plus/search-domain/pipelines/positive-ev/pipeline';
import { premiumMarketMoversPipelineDefinition } from '~/apps/product-plus/search-domain/pipelines/premium-market-movers/pipeline';
import { trendsPipelineDefinition } from '~/apps/product-plus/search-domain/pipelines/trends/pipeline';

const pipelineRegistry = {
  [bettingSplitsPipelineDefinition.id]: bettingSplitsPipelineDefinition,
  [eventOverviewPipelineDefinition.id]: eventOverviewPipelineDefinition,
  [matchupCentrePipelineDefinition.id]: matchupCentrePipelineDefinition,
  [playerDataPipelineDefinition.id]: playerDataPipelineDefinition,
  [premiumMarketMoversPipelineDefinition.id]: premiumMarketMoversPipelineDefinition,
  [positiveEvPipelineDefinition.id]: positiveEvPipelineDefinition,
  [trendsPipelineDefinition.id]: trendsPipelineDefinition,
} as const;

type PipelineRegistry = typeof pipelineRegistry;
type PipelineId = Extract<keyof PipelineRegistry, SearchDomainIndexName>;

function isPipelineId(indexName: string): indexName is PipelineId {
  return indexName in pipelineRegistry;
}

export function getSearchPipelineDefinitionByIndex(indexName: SearchDomainIndexName) {
  if (!isPipelineId(indexName)) return undefined;
  return pipelineRegistry[indexName];
}
